import { getLangLabelFromLocale, Locale, locales } from '@repo/utils'
import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import { Modal } from '../../modal'
import { useLocale } from '../../../../hooks/use-locale'
import Button from '../../../atoms/fields/Button/Button'
import { BUTTON_COLOR } from '../../../atoms/fields/Button/button.enum'
import ControlledSelectField from '../../../forms/select-field/ControlledSelectField'

type LocaleSelectorModalProps = {
  isOpen: boolean
  onSubmit: (locale: Locale) => void
  onClose: () => void
}

const langOptions = locales.map((locale) => ({
  value: locale,
  label: getLangLabelFromLocale(locale),
}))

export function LocaleSelectorModal({
  isOpen,
  onClose,
  onSubmit,
}: LocaleSelectorModalProps) {
  const { locale } = useLocale()
  const intl = useIntl()
  const { control, getValues, reset } = useForm<{ locale: Locale }>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      locale,
    },
  })

  useEffect(() => {
    reset({ locale })
  }, [isOpen])

  const handleSubmit = () => {
    onSubmit(getValues('locale'))
    onClose()
  }

  return (
    <Modal
      title={intl.formatMessage({
        id: 'ui.LocaleSelectorModal.modalTitle',
        defaultMessage: 'Paramètres d’affichage',
      })}
      isOpen={isOpen}
      closeModal={onClose}
      className={s.modal}
      noScroll={true}
      renderButtons={() => (
        <form onSubmit={handleSubmit}>
          <div className={s.footer}>
            <Button color={BUTTON_COLOR.TERTIARY} onClick={onClose}>
              <FormattedMessage
                id='ui.LocaleSelectorModal.cancel'
                defaultMessage='Annuler'
              />
            </Button>
            <Button type='submit' name='save'>
              <FormattedMessage
                id='ui.LocaleSelectorModal.save'
                defaultMessage='Enregistrer'
              />
            </Button>
          </div>
        </form>
      )}
    >
      <div className={s.contentModal}>
        <div className={s.select}>
          <div>
            <FormattedMessage
              id='ui.LocaleSelectorModal.lang'
              defaultMessage='Langue'
            />
          </div>
          <ControlledSelectField
            className={s.selectField}
            control={control}
            name='locale'
            rules={{
              required: intl.formatMessage({
                id: 'ui.LocaleSelectorModal.requiredField',
                defaultMessage: 'Ce champ est requis',
              }),
            }}
            options={langOptions}
            placeholder={intl.formatMessage({
              id: 'ui.LocaleSelectorModal.enterHere',
              defaultMessage: 'Écrire ici',
            })}
            fullWidth={true}
          />
        </div>
      </div>
    </Modal>
  )
}
